module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: 'zenui-icon-' + _vm.name
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75a813c1!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/icon/src/icon.vue
// module id = 141
// module chunks = 2 3